enum DialogBoxActionType {
    OPEN_DIALOG_BOX = "OPEN_DIALOG_BOX",
    CLOSE_DIALOG_BOX = "CLOSE_DIALOG_BOX",
    SHOW_SPINNER_IN_DIALOG_BOX = "SHOW_SPINNER_IN_DIALOG_BOX",
    SHOW_ERROR_IN_DIALOG_BOX = "SHOW_ERROR_IN_DIALOG_BOX",
}

export default DialogBoxActionType;
